<template>
  <div v-if="message" class="row-alert" :class="{ 'row-alert--above-row': aboveRow }">
    <form-alert :key="alertKey" :message="message" :type="type" scroll-on-mount flush @dismiss="$emit('dismiss')" />
  </div>
</template>

<script>
import FormAlert from '@/components/FormAlert'

// A message overlaid on the bottom of the row above (its parent must be a zero-height, relatively
// positioned anchor — GridTable's `before-row` slot is one), so it appears right over the row it is
// about without pushing the table apart. `alertKey` changes for every new message, even with the
// same text, so it re-appears. Click dismisses it.
export default {
  name: 'RowAlert',
  components: { FormAlert },
  props: {
    message: { type: String, default: null },
    type: { type: String, default: 'success' },
    alertKey: { type: [Number, String], default: 0 },
    // The alert lives inside a (position: relative) table row instead of a zero-height anchor above
    // it: place its bottom edge on that row's top edge.
    aboveRow: { type: Boolean, default: false }
  }
}
</script>

<style scoped>
.row-alert {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 0;
}

.row-alert--above-row {
  bottom: 100%;
}

/* Absolute as well: while a new message replaces the old one (which is still fading out) the two
   overlap in the same spot instead of stacking and shoving each other upwards. */
.row-alert >>> .form-alert {
  position: absolute;
  right: 8px;
  bottom: 6px;
  left: 8px;
}

.row-alert >>> .alert {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}
</style>



// WEBPACK FOOTER //
// src/components/RowAlert.vue